import * as React from "react";
import "./radio-option.scss";
import {Radio} from "../../../../../common/design2/radio/radio";
import {cx} from "emotion";

export const RadioOption = ({selected, label, subtitle=undefined, style=undefined, onSelect, extra=undefined, xdQaName=undefined}) => (
    <div className={cx("radio-option-86n", style?.color)}>
        <div
            className="line1"
            onClick={() => !selected && onSelect()}
        >
            {Radio({
                selected,
                xdQaName,
            })}

            <div className="label" xd-qa-type="label" xd-qa-name={xdQaName}>
                {label}
            </div>
            {subtitle && (
                <div className="sub-title" xd-qa-type="label" xd-qa-name={xdQaName ? (xdQaName + " Description") : undefined}>
                    {subtitle}
                </div>
            )}
        </div>

        {extra && (
            <div className="extra">
                {extra}
            </div>
        )}
    </div>
);
